<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { BackspaceOutlined } from '@xpos/icons-svg';
const $emit = defineEmits(['input', 'change', 'update:modelValue', 'disabled-click']);
// single outputs a single value only
const $props = defineProps(['modelValue', 'single', 'disabled', 'clearOnBackspace', 'stringMode']);

const isDefaultValue = ref(true); // First edit replaces the default value
const isZeroPadding = ref(false); // Tracks temporary zero padding for decimal input
const currentValue = ref($props.modelValue || '');
const handleClick = (val: string) => {
  if ($props.disabled) { $emit('disabled-click'); return; }
  let newVal = currentValue.value;
  if ($props.single) {
    newVal = val;
    $emit('update:modelValue', newVal);
    $emit('change', newVal);
    $emit('input', newVal);
    return;
  } else {
    const valueString = currentValue.value.toString();

    if (val === 'backspace') {
      if ($props.clearOnBackspace !== undefined) newVal = '';
      else {
        newVal = valueString.slice(0, -1);
        if (newVal == '') {
          newVal = 0;
        } else if (newVal.endsWith('.')) {
          newVal = newVal.slice(0, -1);
        }
      }
    } else {
      if ($props.stringMode !== undefined) newVal = isDefaultValue.value ? val : valueString + val;
      else if (isDefaultValue.value) {
        if (val == '.') {
          val = '0.0';
          isZeroPadding.value = true;
        }
        newVal = val;
      } else {
        if (val === '0') {
          if (valueString == '0') {
            val = '';
          }
        } else if (val != '0' && val != '.' && /^0+$/.test(currentValue.value)) {
          currentValue.value = '';
          isZeroPadding.value = false;
          newVal = '';
        } else if (val == '.') {
          if (valueString.includes('.')) {
            val = '';
          } else {
            val = '.0';
            isZeroPadding.value = true;
          }
        } else if (isZeroPadding.value) {
          isZeroPadding.value = false;
          newVal = valueString.slice(0, -1);
        }
        newVal += val;
      }
    }
    if (isDefaultValue.value) {
      isDefaultValue.value = false;
    }
  }

  // if (newVal != currentValue.value) {
  currentValue.value = newVal;
  $emit('update:modelValue', newVal);
  $emit('change', newVal);
  $emit('input', newVal);
  // }
};

watch(
  () => $props.modelValue,
  (newVal) => {
    currentValue.value = newVal;
  },
);

const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
</script>

<template>
  <div class="x-keyboard">
    <div v-for="(k, index) in keys" class="key-item key-item--border-bottom" @click="handleClick(k)">
      {{ k }}
    </div>
    <div class="key-item" @click="handleClick('.')">.</div>
    <div class="key-item" @click="handleClick('0')">0</div>
    <div class="key-item" @click="handleClick('backspace')">
      <el-icon size="20" class="align-middle">
        <BackspaceOutlined />
      </el-icon>
    </div>
  </div>
</template>

<style lang="sass">
.x-keyboard
  display: flex
  flex-wrap: wrap
  border: 1px solid #B8B8B8
  border-radius: var(--radius-10)
  user-select: none
  .key-item
    font-size: var(--fs-20)
    width: 33.33%
    height: 50px
    line-height: 50px
    text-align: center
    cursor: pointer
    &:nth-child(3n)
      border-left: 1px solid #B8B8B8
    &:nth-child(3n-1)
      border-left: 1px solid #B8B8B8
    &--border-bottom
      border-bottom: 1px solid #B8B8B8
</style>
